import { appRoutes } from "~/constants/appRoutes.ts";

export const INTENDED_LOCATION_KEY = "intendedLocation";

export const deleteIntendedLocation = () => {
	localStorage.removeItem(INTENDED_LOCATION_KEY);
};

export const getIntendedLocation = (): string | null => {
	const location = localStorage.getItem(INTENDED_LOCATION_KEY);
	if (location) {
		return JSON.parse(location);
	}
	return null;
};

// The public pages are never a target: a stored login or reset link would send the user back to it after the login.
const isPublicPath = (path: string) => [
	appRoutes.base().path,
	appRoutes.login().path,
	appRoutes.passwordResetRequest().path,
].includes(path) || path.startsWith(appRoutes.passwordReset().path.replace(":token", ""));

// The full location is stored (path, query, hash), so a deep link opens with its filter after the login.
export const setIntendedLocation = (intendedLocation: string | null = null) => {
	const { pathname, search, hash } = window.location;
	intendedLocation = intendedLocation || `${pathname}${search}${hash}`;

	if (!isPublicPath(intendedLocation.split(/[?#]/)[0])) {
		localStorage.setItem(INTENDED_LOCATION_KEY, JSON.stringify(intendedLocation));
	}
};
